import { createContext, useContext } from 'react'

export const MeetingsPageTourContext = createContext(null)

export const useMeetingsPageTourContext = () => useContext(MeetingsPageTourContext)
